// src/lib/placeIcon.js — THE map from a locations-dictionary type to the icon that draws it
// (2026-08-27). ONE definition: deskFeed's `LOC_TYPE_ICON` re-exports this, the Desk search
// dropdown reads it, and a new surface must import it rather than restate it.
//
// It exists because there WERE two answers. deskFeed's map dressed the card-face and
// lineage-modal proximity chips; the search dropdown had no map at all and drew the generic
// 📍 on every row — beside a tag that said "metro". The owner caught the dropdown; the
// duplicate is why the two could disagree in the first place.
//
// Values are Material Symbols names resolved by <Icon name=…> (src/components/Icon.jsx).
// This map is also what sent the whole icon set to Material: Lucide had no metro glyph, so
// the old values were `train-front` (a mainline train) for the underground and `droplets`
// for a city square — approximations the row's own words contradicted.
//
// ⚠️ Dependency-free on purpose. It maps a type to a NAME and draws nothing, so a surface
// that cannot afford the icon component — the public fill form keeps its own emoji chips
// (FillApp.jsx NEAR_EMOJI), because it is a standalone bundle a stranger loads on a phone —
// can still read it without pulling the app in.
//
// A type with no entry gets null: the caller keeps its generic pin. Never guess a glyph —
// a wrong picture is worse than a neutral one.
export const PLACE_TYPE_ICON = {
  metro: 'subway',
  park: 'park',
  // The city square (მოედანი). Material has no fountain, and the meaning is "a public place
  // in town" — not the water the ⛲ emoji happened to carry.
  square: 'location_city',
  mall: 'local_mall',
  // Bazaar/market — the shopfront. Deliberately NOT `local_mall`: one icon one meaning, and
  // these are different kinds of place to live beside.
  market: 'storefront',
  complex: 'apartment',
  school: 'school',
  // A university (columned facade) vs a landmark (museum): Lucide made the two share its
  // `landmark`, which is the collision Icon.jsx's one-icon-one-meaning rule exists to stop.
  university: 'account_balance',
  landmark: 'museum',
  hospital: 'local_hospital',
}

export const placeIcon = type => PLACE_TYPE_ICON[type] || null
